module.exports = __webpack_public_path__ + "img/watermark.1b795e1e.png";